import gettext from '@sdk/lang/gettext';
import formatTime from '@sdk/utils/dateFormat/formatTime';
import getRealDate from '@sdk/utils/getRealDate';
import addDays from '@sdk/utils/addDays';
import addJoin from '@sdk/utils/addJoin';
import type { ShiftTemplateFromApi } from '@sdk/shifts/types/apiTypes';
import { ShiftTemplateType } from '@sdk/shifts/types/ShiftTemplatesType';
import type { PersonasDict } from '@sdk/personaCollection/types/PersonasDict';

export const extendShiftTemplates = (
  shiftTemplates: ShiftTemplateFromApi[],
  shiftBreakType: number,
  personasDict: PersonasDict
): ShiftTemplateType[] => {
  const extendedShiftTemplates: any = [...shiftTemplates];

  extendedShiftTemplates.forEach((template) => {
    template.deleted = false;
    if (template.start) {
      template.dtstart = getRealDate(`2016-01-01T${template.start}:00`);
    } else {
      template.deleted = true;
    }

    if (template.end) {
      template.dtend = getRealDate(`2016-01-01T${template.end}:00`);
      if (template?.dtstart && template.dtstart > template.dtend) {
        template.dtend = addDays(template.dtend, 1);
      }
    } else {
      template.deleted = true;
    }

    template.duration = (template.dtend - template.dtstart) / 1000 / 60 / 60;
    if (template.duration === 0) {
      template.durationLabel = gettext('24 hours');
    } else {
      template.durationLabel = `${Math.round(template.duration * 10) / 10} hours`;
    }

    template.time = `${formatTime(template.dtstart)} - ${formatTime(template.dtend)}`;

    handleTemplateLocations(template, personasDict);

    if (template.breakDuration) {
      template.breakLabel = `${template.breakDuration} minutes`;
    } else {
      template.breakLabel = gettext('No break');
    }

    if (shiftBreakType) {
      if (template.breakDuration) {
        template.timeAux = `${template.breakDuration}min break`;
      } else {
        template.timeAux = `${template.breakLabel}`;
      }
    }
  });

  return extendedShiftTemplates;
};

const handleTemplateLocations = (template: ShiftTemplateType, personasDict: PersonasDict): void => {
  if (template.locations?.length) {
    const existingLocations = template.locations.filter((loc) => personasDict[loc.id]);
    if (!existingLocations.length) {
      template.deleted = true;
    }

    template.locationLabel = addJoin(existingLocations.map((loc) => personasDict[loc.id].name));
  } else {
    template.locationLabel = gettext('All locations');
  }
};
